import React, { createRef } from 'react';
import { classNames, formatMiles } from '../../../utils';
import { ChevronRightIcon, PaymentCashIcon, PaymentFastIcon, PaymentMobileIcon, PaymentMonthlyIcon, PaymentSlowIcon, PaymentTransferIcon, PaymentZelleIcon } from '../../../assets/icons';
import { connect } from 'react-redux';

const PAYMENT_TYPE = {
  MONTHLY: 1,
  ANNUAL: 2,
};

class Payment extends React.Component {

  state = {
    form: {
      type: PAYMENT_TYPE.MONTHLY,
      amountToPay: 0,
    },
    request: null,
  }

  cartButtonRef = createRef();
  goBack = createRef();

  componentDidMount() {
    this.cartButtonRef.current = document.getElementById('header-cart');
    this.cartButtonRef.current.classList.add('hidden');
    this.goBack.current = document.getElementById('header-goback');
    this.goBack.current.classList.remove('hidden');

    const request = this.props.request?.purchase;
    if (!request) this.props.history.replace('/');

    this.setState({
      form: {
        ...this.state.form,
        amountToPay: request?.total,
      },
      request,
    });
  }

  componentWillUnmount() {
    this.cartButtonRef.current.classList.remove('hidden');
    this.goBack.current.classList.add('hidden');
  }

  change = (value,target) => {
    this.setState({
      form: {
        ...this.state.form,
        [target]: value,
      },
    });
  }

  goTo = (route) => {
    this.props.history.push(route);
  }

  render() {

    const { form } = this.state;

    return (
      <div className="w-full sm:w-[30rem] mx-auto flex flex-col mt-8 lg:mt-0">
        {/* <Text style={styles.description}>Selecciona el monto a pagar</Text> */}

        <div className="w-full mt-4 mb-8 flex justify-center relative">
          <div
            className={classNames(
              'rounded-lg flex flex-1 justify-center items-center p-2',
              form.type === PAYMENT_TYPE.MONTHLY ? 'bg-darkBlue' : 'bg-gray5'
            )}
          >
            <p className="flex-1 text-white text-xl font-semibold text-center">
              Monto:
            </p>
            <div className="flex-1 flex">
              <div className="w-8 h-8 rounded-full flex justify-center items-center bg-white mr-2">
                <img src={PaymentMonthlyIcon} className="w-5 h-5 object-contain" alt="" />
              </div>
              <p className={classNames('text-2xl font-bold text-center', form.type === PAYMENT_TYPE.MONTHLY ? 'text-white' : 'text-darkBlue')}>
                { formatMiles(this.state.form.amountToPay) }
              </p>
            </div>
            {/* <div className="flex-1" /> */}
          </div>
        </div>

        {/* <PaymentMethod
          label="Domiciliación"
          icon={PaymentAddressIcon}
          color="bg-blue2"
          onClick={() => this.goTo('ClientPaymentAddress')}
        /> */}

        <PaymentMethod
          label="Débito Inmediato"
          icon={PaymentMobileIcon}
          color="bg-green"
          onClick={() => this.goTo('/pagar/pago-movil/directo')}
          isInstant
        />

        <PaymentMethod
          label="Pago Móvil"
          icon={PaymentMobileIcon}
          color="bg-darkBlue"
          onClick={() => this.goTo('/pagar/pago-movil/banco')}
          isInstant
        />

        <PaymentMethod
          label="Zelle"
          icon={PaymentZelleIcon}
          color="bg-[#6b1dd5]"
          onClick={() => this.goTo('/pagar/zelle')}
          isInstant
        />

        <PaymentMethod
          label="Transferencia"
          icon={PaymentTransferIcon}
          color="bg-[#06C5F2]"
          onClick={() => this.goTo('/pagar/transferencia')}
        />

        <PaymentMethod
          label="Depósito"
          icon={PaymentCashIcon}
          color="bg-yellow"
          onClick={() => this.goTo('/pagar/deposito')}
        />
      </div>
    );
  }
}

const PaymentMethod = ({ icon, color, label, onClick, isInstant }) => (
  <button
    className="flex justify-between items-center bg-white rounded-lg border border-gray6 p-2 mb-4"
    onClick={onClick}
  >
    <div className="flex items-center gap-2">
      <div className={classNames('w-12 h-12 flex justify-center items-center rounded-md', color)}>
        <img src={icon} className="w-8 h-8 object-contain" alt="" />
      </div>
      <div className="flex flex-1 flex-col justify-center text-left">
        <p className="text-xl font-semibold text-darkBlue text-wrap">
          { label }
        </p>
        <div className="flex items-center gap-1">
          <p className='text-sm text-[#999999] font-semibold'>
            { isInstant ? 'Inmediata' : 'Notificando' }
          </p>
          <img
            src={isInstant ? PaymentFastIcon : PaymentSlowIcon}
            className="w-4 h-4 object-contain mr-2"
            alt=""
          />
        </div>
      </div>
    </div>
    <img src={ChevronRightIcon} className="w-4 h-4 object-contain" alt="" />
  </button>
);

export default connect(state => ({
  request: state.request,
}))(Payment);
